import React from "react";
import "./App.css";
import { LanguageProvider } from "./context/LanguageContext";
import { useSEO } from "./hooks/useSEO";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import MenuAttuale from "./components/MenuAttuale";
import Menu from "./components/Menu";
import Gallery from "./components/Gallery";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const SiteContent = () => {
  useSEO();
  return (
    <div className="App bg-stone-950 min-h-screen min-h-svh">
      <Navbar />
      <Hero />
      <About />
      <MenuAttuale />
      <Menu />
      <Gallery />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <SiteContent />
    </LanguageProvider>
  );
}

export default App;
